import gql from 'graphql-tag';

const CREATE_BRAND = gql`
  mutation CreateBrand($data: CreateBrandInput!) {
    createBrand(data: $data) {
      id
      name
      website
      workspaceId
      isDefault
      custom {
        id
        name
        website
        workspaceId
      }
    }
  }
`;

const DELETE_BRAND_BY_ID = gql`
  mutation DeleteBrandById($id: ID!) {
    deleteBrandById(id: $id) {
      id
      name
      website
    }
  }
`;

const UPDATE_BRAND_BY_ID = gql`
  mutation UpdateBrandById($data: UpdateBrandInput, $id: ID!) {
    updateBrandById(data: $data, id: $id) {
      id
      name
      website
      custom {
        id
        name
        website
      }
    }
  }
`;

export default {
  CREATE_BRAND,
  DELETE_BRAND_BY_ID,
  UPDATE_BRAND_BY_ID,
};
